<template lang="pug">
  .table-responsive
    table#tbPermisos.table.is-striped.is-fullwidth
      thead
        tr
          th #
          th Usuario
          th SCA TPA
          th SCA IRGE
          th Inventarios
          th Responsivas
          th Requisiciones
          th Combustibles
          th Tarjetas
          th Tags
          th Vehiculos
          th Monitoreo
          th Reportes
          th Visitas
          th Facturas
      tbody
        tr(v-for="(data, index) in permisos" :key="data.id")
          td 
            a.button.is-black.is-rounded.is-small
              | {{ index + 1 }}
          td
            span.tag.is-light {{ data.nombre }}
            
          td  
            a.button.is-small.is-warning.is-rounded(@click="changePermisos(data, 'permisos_sca_tpa')")
              | {{ data.permisos_scaTPA }}
              | &nbsp
              span.icon
                i.fas.fa-pencil-alt
          td  
            a.button.is-small.is-warning.is-rounded(@click="changePermisos(data, 'permisos_sca_irge')")
              | {{ data.permisos_scaIRGE }}
              | &nbsp
              span.icon
                i.fas.fa-pencil-alt
          td  
            a.button.is-small.is-warning.is-rounded(@click="changePermisos(data, 'permisos_inventarios')")
              | {{ data.permisos_inventarios }}
              | &nbsp
              span.icon
                i.fas.fa-pencil-alt
          td  
            a.button.is-small.is-warning.is-rounded(@click="changePermisos(data, 'permisos_responsivas')")
              | {{ data.permisos_responsivas }}
              | &nbsp
              span.icon
                i.fas.fa-pencil-alt
          td  
            a.button.is-small.is-warning.is-rounded(@click="changePermisos(data, 'permisos_requisiciones')")
              | {{ data.permisos_requisiciones }}
              | &nbsp
              span.icon
                i.fas.fa-pencil-alt
          td  
            a.button.is-small.is-warning.is-rounded(@click="changePermisos(data, 'permisos_combustibles')")
              | {{ data.permisos_combustibles }}
              | &nbsp
              span.icon
                i.fas.fa-pencil-alt
          td  
            a.button.is-small.is-warning.is-rounded(@click="changePermisos(data, 'permisos_tarjetas')")
              | {{ data.permisos_tarjetas }}
              | &nbsp
              span.icon
                i.fas.fa-pencil-alt
          td  
            a.button.is-small.is-warning.is-rounded(@click="changePermisos(data, 'permisos_tags')")
              | {{ data.permisos_tags }}
              | &nbsp
              span.icon
                i.fas.fa-pencil-alt
          td  
            a.button.is-small.is-warning.is-rounded(@click="changePermisos(data, 'permisos_vehiculos')")
              | {{ data.permisos_vehiculos }}
              | &nbsp
              span.icon
                i.fas.fa-pencil-alt
          td  
            a.button.is-small.is-warning.is-rounded(@click="changePermisos(data, 'permisos_monitoreo')")
              | {{ data.permisos_monitoreo }}
              | &nbsp
              span.icon
                i.fas.fa-pencil-alt
          td  
            a.button.is-small.is-warning.is-rounded(@click="changePermisos(data, 'permisos_reportes')")
              | {{ data.permisos_reportes }}
              | &nbsp
              span.icon
                i.fas.fa-pencil-alt
          td  
            a.button.is-small.is-warning.is-rounded(@click="changePermisos(data, 'permisos_visitas')")
              | {{ data.permisos_visitas }}
              | &nbsp
              span.icon
                i.fas.fa-pencil-alt
          td  
            a.button.is-small.is-warning.is-rounded(@click="changePermisos(data, 'permisos_facturas')")
              | {{ data.permisos_facturas }}
              | &nbsp
              span.icon
                i.fas.fa-pencil-alt
</template>

<script>
  export default {
    name: 'Tb_Permisos',
    props: {
      permisos: {
        type: Array,
        default: []
      },
    },
    data() {
      return {
        itemSel: {},
      }
    },
    methods: {
      changePermisos(permiso, target) {
        const myObj = {
          permiso: target,
          data: permiso,
        }
        this.$emit('showModal', myObj)
      }
    },
  }
</script>

<style lang="css" scoped>
  .table-responsive {
    overflow-x: auto;
    margin: 10px auto;
  }
</style>


// WEBPACK FOOTER //
// src/components/usuarios_Componentes/Tb_Permisos.vue